export default function trackSearchResult(query, resultsCount, type) {
	try {
		const { adobeDataLayer } = window;
		if (adobeDataLayer) {
			adobeDataLayer.push({
				event: 'searched',
				searchInfo: {
					searchQuery: query,
					searchHits: resultsCount,
					searchCategory: type
				}
			});
		}
	} catch (error) {
		// eslint-disable-next-line no-console
		console.error(`This is issue in this operation : ${error.name} : ${error.message}`);
	}
}
